var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cv-file-uploader',{ref:_vm.fileUploader.ref,attrs:{"label":_vm.getMessage(_vm.fileUploader.title),"helperText":_vm.getMessage(_vm.fileUploader.helperText),"drop-target-label":_vm.getMessage(_vm.fileUploader.uploadText),"accept":".json","clear-on-reselect":true,"multiple":false,"removable":true},on:{"change":_vm.onFileUploaderChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }